module.exports = __webpack_public_path__ + "img/mob3.85b41f7c.png";